import React, { useEffect, useRef, useState } from 'react'
import { CSVLink } from 'react-csv';
import { Link, useNavigate } from 'react-router-dom';
import PageTitle from '../../../components/partials/PageTitle'
import pdf from "../../../assets/images/img-icons/pdf.png";
import excel from "../../../assets/images/img-icons/excel.png";
import { getAllForms, resetSingleForm } from '../../../redux/slice/form/formSlice';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import PaginationLinks from '../../../components/pagination/PaginationLinks';
import { MdRemoveRedEye } from 'react-icons/md';
import moment from 'moment';
const Forms = () => {

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const { all_forms, isSuccess } = useSelector((state) => state.form)

    const { user_permissions } = useSelector((state) => state?.auth?.user);

    const [hasCreateForm, setHasCreateForm] = useState(null)
    const [hasViewForm, setHasViewForm] = useState(null)
    const [filterBy, setFilterBy] = useState('');

    const CCPdfRef = useRef()

    const breadcrumb = {
        from: {
          title: "Forms",
          link: "/admin/settings/forms",
        },
        current: {
          title: "Forms Table",
          link: null,
        },
    };

    const fetchFormsHandler = async (pageNum) => {
        // setPageNumber(pageNum);
        dispatch(getAllForms({pageNum, search: filterBy}));
    };

    const handleSearch = (e) => {
      e.preventDefault();
      if (filterBy?.length) {
        const payload = {
          search: filterBy,
          pageNum: 1
        };
        dispatch(getAllForms(payload));
      }
    };

    useEffect(() => {
      if (!filterBy) {
        dispatch(getAllForms({pageNum:1, search:''}))
      }
      }, [dispatch, filterBy])

      useEffect(() => {
        if (isSuccess) {
          dispatch(resetSingleForm())
        }
      }, [dispatch, isSuccess])

      useEffect(() => {
        if (!user_permissions?.some(permission => permission.name === 'custom form module')) {
          navigate('/admin/dashboard')
        }
    
        setHasCreateForm(user_permissions?.some(permission => permission.name === 'create custom form'))
        setHasViewForm(user_permissions?.some(permission => permission.name === 'view custom form'))
      }, [navigate, user_permissions])
    
  return (
    <div>
        {/* page title */}
        <PageTitle title='Custom Forms' breadcrumb={breadcrumb} />
        {/* end page title */}
        <div className='row card p-1' style={{ margin: "auto 1px" }}>
            <div className='mb-1 pb-1 border border-bottom-1 border-start-0 border-end-0 border-top-0'>
                <div className={`d-flex justify-content-between align-items-center`}>
                    <div>
                      {hasCreateForm && <Link
                          className='d-flex gap-2 justify-content-center align-items-center rounded-1 btn-primary cursor-p px-3'
                          style={{ height: "30px", padding: "10px 10px" }}
                          to='/admin/settings/forms/add-form'
                      >
                          <span>
                              <i className='mdi mdi-plus fs-4'></i>
                          </span>
                          <span  
                              className='text-dark pe-2 text-white'
                          >
                              Create Custom Form
                          </span>
                      </Link>}
                    </div>
                    <div className='d-flex justify-content-between align-items-center gap-3'>
                        <form
                          onSubmit={handleSearch}
                        className='d-flex bg-primary-1 align-items-center '
                        style={{ height: "30px", width: "217px" }}
                        >
                        <input
                            type='search'
                            value={filterBy}
                            className='border-0'
                            placeholder='Search...'
                            onChange={(e) => setFilterBy(e.target.value)}
                            style={{ height: "28px", marginLeft: "1px", outline: "none" }}
                        />
                        <button
                            type='submit'
                            className='btn btn-primary btn-sm d-flex align-items-center gap-1'
                            style={{ height: "28px" }}
                        >
                            <i className='uil uil-search text-white fs-4'></i>
                        </button>
                        </form>
                        <div className=' d-flex align-items-center border '>
                            <span
                                className='bg-info me-2 text-white'
                                style={{ padding: "3px" }}
                            >
                                Export to
                            </span>
                            <span
                                href='#'
                                id='btnExport'
                                className='me-1'
                                title='Export to Pdf'
                                // onClick={generatePDF}
                            >
                                <img src={pdf} alt='export-pdf' style={{ height: "20px" }} />
                            </span>
                            <CSVLink
                                data={[]}
                                style={{ fontWeight: "bolder" }}
                                filename='Available Users'
                            >
                                <span
                                href='#'
                                id='btnExport'
                                className='mr-1'
                                title='Export to Excel'
                                >
                                <img
                                    src={excel}
                                    alt='export-excel'
                                    style={{ height: "20px", marginRight: "5px" }}
                                />
                                </span>
                            </CSVLink>
                        </div>
                    </div>
                </div>
            </div>
            <div className='col-12'>
              <div className='position-relative'>
                <div className='row'>
                  <div className='col-sm-12'>
                    <div className='table-responsive'>
                      <table
                        className='table table-centered table-striped nowrap w-100 no-footer'
                        ref={CCPdfRef}
                      >
                        <thead>
                          <tr>
                            <th
                              className='sorting'
                              tabIndex='0'
                              rowSpan='1'
                              colSpan='1'
                              style={{ width: "225.8px" }}
                              aria-label='Customer: activate to sort column ascending'
                            >
                                Name
                            </th>
                            <th
                              className='sorting'
                              tabIndex='0'
                              rowSpan='1'
                              colSpan='1'
                              style={{ width: "167.8px" }}
                              aria-label='Email: activate to sort column ascending'
                            >
                              Date
                            </th>
                              {hasViewForm && <th
                                className='sorting text-center'
                                tabIndex='0'
                                rowSpan='1'
                                colSpan='1'
                                style={{ width: "165.8px" }}
                                aria-label='Status: activate to sort column ascending'
                              >
                                Action
                              </th>}
                          </tr>
                        </thead>
                        {all_forms?.data?.length ? (
                          <tbody>
                            {all_forms?.data?.map((item, i) => { return (
                                <tr key={i}>
                                <td>
                                  <span>{item.form_name}</span>
                                </td>
                                <td className=''>{moment(`${item?.date}`).format("LL")}</td>
                                {hasViewForm && <td className='text-center'>
                                  <Link
                                    to={`/admin/settings/forms/${item?.id}`}
                                    className='text-left'
                                  >
                                    <MdRemoveRedEye
                                      className='text-primary'
                                      style={{
                                        fontSize: "20px",
                                        textAlign: "start",
                                      }}
                                    />
                                  </Link>
                                </td>}
                              </tr>
                            )})}
                          </tbody>
                        ) : null}
                      </table>
                    </div>
                    {all_forms?.data?.length < 1 ? (
                      <h5 className='alert alert-info'>No result found!</h5>
                    ) : null}
                    <div className='row mt-2'>
                      <div className='col-sm-12 col-md-6'>
                        <div
                          className='dataTables_info table-pages'
                          id='products-datatable_info'
                          role='status'
                          aria-live='polite'
                        >
                          Showing offices{" "}
                          {all_forms.from} to{" "}
                          {all_forms.to} of{" "}
                          {all_forms.total}
                        </div>
                      </div>
                      <div className='col-sm-12 col-md-6'>
                        <PaginationLinks
                          paginationData={
                            all_forms
                          }
                          getNextPage={fetchFormsHandler}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {/* {(isFiltering || isSearching) && (
                  <div
                    className='position-absolute top-0 start-0 end-0 bottom d-flex justify-content-center align-items-center transparent-primary z-1000 '
                    style={{ height: "100%" }}
                  >
                    <div className='mx-auto'>
                      <BounceLoader
                        color='#090b8f'
                        loading={true}
                        // cssOverride={override}
                        size={50}
                        aria-label='Loading Spinner'
                        data-testid='loader'
                        className='ms-3'
                      />
                      <span className='fw-bolder text-primary-1 ms-2'>
                        Please wait...
                      </span>
                    </div>
                  </div>
                )} */}
              </div>
            </div>
        </div>
    </div>
  )
}

export default Forms